import { Box, Card } from '@mui/material';
import { useForm } from 'react-hook-form';
import CommonOfflinePaymentInfo from './CommonOfflinePaymentInfo';

interface FormData {
  bank_ac_no: string;
  bank_name: string;
  amount: string;
  deposit_date: string;
  branch_name: string;
  reference_no: string;
  bank_slip: FileList | null;
  type: 'online' | 'offline';
}

const PaymentOfflineInfromation = ({
  setPaymentOfflineInformation,
}: {
  setPaymentOfflineInformation: React.Dispatch<
    React.SetStateAction<null | any>
  >;
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    clearErrors,
    setError,
    control,
    setValue,
    watch,
  } = useForm<FormData>({
    defaultValues: {
      bank_ac_no: '00890320000141',
      bank_name: 'Trust Bank',
      amount: '65300',
      deposit_date: '',
      branch_name: '',
      reference_no: '',
      bank_slip: null,
      type: 'online',
    },
  });

  const onSubmit = (data: FormData) => {
    console.log('Form Data:999999999999999999999999', data);
  };

  return (
    <Card>
      <Box
        sx={{
          boxShadow: 3,
          borderRadius: 2,
        }}
      >
        <Box
          sx={{
            padding: '20px',
            boxShadow: 3,
            borderRadius: 2,
          }}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <CommonOfflinePaymentInfo
              register={register}
              errors={errors}
              clearErrors={clearErrors}
              setError={setError}
              sm={4}
              md={4}
              lg={4}
              setPaymentOfflineInformation={setPaymentOfflineInformation}
              control={control}
              onlinePaymentAmount={65300}
            />
          </form>
        </Box>
      </Box>
    </Card>
  );
};

export default PaymentOfflineInfromation;
